export const config = {
  connectionString:
    'InstrumentationKey=04d2997c-6003-4de2-8ddf-696c9b445ad1;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/',
};
